var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoReadPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6601_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6601_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5L12.5 7.5L8 4.5V10.5ZM2 16.5V3C2 2.5875 2.14687 2.23438 2.44063 1.94063C2.73438 1.64687 3.0875 1.5 3.5 1.5H15.5C15.9125 1.5 16.2656 1.64687 16.5594 1.94063C16.8531 2.23438 17 2.5875 17 3V12C17 12.4125 16.8531 12.7656 16.5594 13.0594C16.2656 13.3531 15.9125 13.5 15.5 13.5H5L2 16.5ZM4.3625 12H15.5V3H3.5V12.8438L4.3625 12Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoReadPlay);
export default __webpack_public_path__ + "static/media/auto_read_play.7ac1e8f8d7d0b53fc35e174c544990cd.svg";
export { ForwardRef as ReactComponent };